import { render, staticRenderFns } from "./sharebox.vue?vue&type=template&id=bee54552"
import script from "./sharebox.vue?vue&type=script&lang=js"
export * from "./sharebox.vue?vue&type=script&lang=js"
import style0 from "./sharebox.vue?vue&type=style&index=0&id=bee54552&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports